import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { NavigationModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class NavigationStore implements ltFramework.INavigationStore {
	public getInitialData(): ltFramework.INavigation {
		return (Store.state as ltFramework.IStoreState).navigationModule.navigation;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(
			NavigationModuleConstant.name + '/' + NavigationModuleConstant.action.initialize
		);
	}

	public listen(callback: (state: ltFramework.INavigation) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(NavigationModuleConstant.name + '/')) {
				callback((state as ltFramework.IStoreState).navigationModule.navigation);
			}
		});
	}
}
